document.addEventListener('DOMContentLoaded', () => {
	const swipers = document.querySelectorAll('.slider-container');

	swipers.forEach((swiper) => {
		const data = swiper.querySelector(`.swiper-data-handler`);
		const mySwiper = data.dataset.class;
		const sectionId = data.dataset.section;
		const swipeEffect = data.dataset.effect;
		const pagination = (data.dataset.pagination);
		const bullets = data.dataset.bullets;
		const buttons = (data.dataset.buttons);
		const autoplay = (data.dataset.autoplay);
		const disableOnInteraction = (data.dataset.disable);
		let colsDesktop = Number(data.dataset.colDesktop);
		let colsMobile = Number(data.dataset.colMobile);
		let colsTablet = Number(data.dataset.colTablet);
		const delay = Number(data.dataset.delay)*1000;
		const speed = Number(data.dataset.speed);

		if (mySwiper == 'feed__slider') {
			colsMobile = 'auto'
			colsTablet = 'auto'
			colsDesktop = 'auto'
		}

		let myPagination = document.querySelector(`.swiper-pagination[data-target="${mySwiper}"]`)
	
		const paginationObj = {
			el: myPagination,
			clickable: true,
		};

		let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="${mySwiper}"]`)
		let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="${mySwiper}"]`)
	
		const navigationObj = {
			nextEl: mySwiperNext,
			prevEl: mySwiperPrev,
		};

		let disableOn = false
		if (disableOnInteraction === 'true') disableOn = true

		const autoplayObj = {
			delay: delay,
			disableOnInteraction: disableOn,
			pauseOnMouseEnter: true,
		};
	
		const swiperObj = {
			slidesPerView: colsMobile,
			slidesPerGroupAuto: true,
			spaceBetween: 20,
			speed: speed,
			autoHeight: true,
			centeredSlides: true,
            watchSlidesProgress: true,
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: colsTablet,
					// slidesPerGroup: colsTablet,
					spaceBetween: 40,
					centeredSlides: false,
				},
				1440: {
					slidesPerView: colsDesktop,
					// slidesPerGroup: colsDesktop,
					spaceBetween: 50,
				},
			},
		}
		
		if (swipeEffect && document.body.clientWidth < 768) {
			swiperObj.effect = swipeEffect;
		}
	
		if (pagination === 'true') {
			swiperObj.pagination = paginationObj;
		}
	
		if (buttons === 'true') {
			swiperObj.navigation = navigationObj;
		}

		if (autoplay === 'true') {
			swiperObj.autoplay = autoplayObj;
		}
	
		let swiperInstance = new Swiper(`.${mySwiper}`, swiperObj);
        // console.log(`Instancia para ${mySwiper}:`, swiperObj)

		// window.addEventListener('resize', () => {
		// 	if (window.innerWidth > 768) {
		// 		swiperInstance.destroy(true, true);
		// 		swiperInstance = new Swiper(`.${mySwiper}`, {
		// 			slidesPerView: colsDesktop,
		// 			spaceBetween: 50,
		// 			keyboard: {
		// 				enabled: true,
		// 			},
		// 			pagination: pagination ? paginationObj : false,
		// 			navigation: buttons ? navigationObj : false,
		// 			autoplay: autoplay ? autoplayObj : false,
		// 		});
		// 	} else if (swiperInstance.params.effect !== swipeEffect) {
		// 		swiperInstance.params.effect = swipeEffect;
		// 		swiperInstance.update();
		// 	}
		// });

		// swiperInstance.on('slideChange', function() {
		// 	swiperInstance.pagination.render();
		// 	swiperInstance.pagination.update();
		// });
	});
});
